import styled from "styled-components";

const Label = styled.span`
  font-size: 14px;
  line-height: 14px;
  margin-right: 4px;
`;
const Value = styled.span`
  font-size: 14px;
  font-weight: 600;
`;
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 14px;
  flex: 1;
`;
export function LabeledText({ label, value }) {
    return (
        <Container>
            <Label>{label}:</Label>
            <Value>{value || '-'}</Value>
        </Container>
    );
}
